<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 选择评分
 * @Date: 2021-09-14 15:24:58
 * @LastEditTime: 2021-11-04 10:05:35
-->

<template>
  <div class="DeliveryType">
    <van-cell is-link :title="config.name" value-class="flex align-center justify-end" @click="openBox">
      <template #value> <span class="store-name ml-10">{{ selectdStoreName }}</span>
      </template>
    </van-cell>
    <van-action-sheet v-model:show="state.show" :title="config.title" @select="openBox">
      <div v-for="item in state.stores" :key="item.value" :class="{selected:item.value === state.selectdStore}" class="flex justify-center align-center pt-10 pb-10 border-bottom li" @click="onSelect(item.value)">
        <span class="ml-10">{{ item.name || '--' }}</span>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {reactive , inject , computed} from "vue"
import {serviceTrack} from 'model/common'
import {useStore} from 'vuex'
export default {
  name:'SelectStars',
  props:{
    val:{
      type:String,
      default:()=>'80'
    },
    config:{
      type:Object,
      default:()=>{
        return {
          title:'Select Stars',
          name:'Stars'
        }
      }
    }

  },
  setup(props,{emit}){
    //交互类型
    const starsArray = [{
      value: '80',
      src: null,
      alt: null,
      name: '5☆+4☆ positive rates (80% + 20%)'
    },
    {
      value: '100',
      src: null,
      alt: null,
      name: '5☆ positive rates'
    },
    {
      value: '60',
      src: null,
      alt: null,
      name: '3☆ positive rates'
    }
    ]

    const common = inject("$common")
    const store=useStore()
    const state = reactive({
      selectdStore : props.val || '100',
      show: false,
      stores:common.starsArray || starsArray
    })

    //打开选项框
    const openBox = ()=>{
      state.show = !state.show
    }
 
    //选择应用的名称
    const selectdStoreName = computed(()=>{
      let tem = null
      state.stores && state.stores.forEach((item)=>{
        if(item.value === state.selectdStore){
          tem = item.name
          return
        }
      })
      return tem
    })
  
    //选择结果
    const onSelect = (val = null)=>{
      openBox()
      state.selectdStore = val
      //暴露值
      emit('select',val)
      serviceTrack(val === '80' ? '5_4stars' : (val === '100' ? '5stars' : '3stars'),store)
    }


    return {
      state,openBox,selectdStoreName,
      onSelect
    }
  }
}

</script>
<style lang="scss" scoped>
// .DeliveryType {
//     position: relative;
//     z-index: 10000;
// }

.store-name,
.li {
  font-size: $fontText;
  color: $fontColor;
}

.selected {
  color: $fontColor;
}

.DeliveryType {
  :deep(.van-cell__title),
  :deep(.van-cell__value) {
    flex: auto;
  }

  &:deep(.van-action-sheet__header) {
    font-weight: bold;
    margin: 0 10px;
    border-bottom: 1px solid $border;
  }

  &:deep(.van-action-sheet__content) {
    padding: 0 10px;
    margin-bottom: 30px;
  }

  &:deep(.van-cell__title) {
    font-weight: bold;
    color: $fontColor;
  }

  :deep(.van-cell__value) {
    overflow: unset;
    white-space: nowrap;
    font-size: 13px;
  }

  &:deep(.van-action-sheet) {
    z-index: 10003 !important;
  }
}
</style>